import React from 'react';
import { Lock, LogOut } from 'lucide-react';
import { api } from '../lib/api';

export default function TopBar({ setScreen, adminAuthed, setAdminAuthed, screen }) {
  const quitAdmin = async () => {
    try {
      await api.del('/api/admin/session');
    } catch {
      /* la session locale est fermée quoi qu'il arrive */
    }
    setAdminAuthed(false);
    setScreen('landing');
  };

  return (
    <div className="topbar">
      <button className="brand" onClick={() => setScreen('landing')}>
        <span className="brandmark"><img src="/logo.svg" alt="" /></span>
        Oliv<span className="grad-text">'IA</span>
      </button>
      <div className="topbar-right">
        {adminAuthed && screen === 'admin' ? (
          <button className="link-btn" onClick={quitAdmin}>
            <LogOut size={15} /> Quitter l'admin
          </button>
        ) : (
          <button className="link-btn subtle" onClick={() => setScreen(adminAuthed ? 'admin' : 'adminLogin')}>
            <Lock size={14} /> Administration
          </button>
        )}
      </div>
    </div>
  );
}
